// // // import React, { useState, useEffect } from 'react';
// // // import { ToastContainer, toast } from 'react-toastify';
// // // import {
// // // 	Box,
// // // 	Button,
// // // 	Grid,
// // // 	Typography,
// // // 	Chip,
// // // 	Dialog,
// // // 	DialogTitle,
// // // 	DialogContent,
// // // 	DialogActions,
// // // 	IconButton,
// // // 	TextField,
// // // } from '@mui/material';
// // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // import CloseIcon from '@mui/icons-material/Close';
// // // import { useNavigate } from 'react-router-dom';
// // // import GetQuotationForm from './GetQuotationForm';
// // // import { createQuotation } from '../../../../../services/api/QuoationAPI';
// // // import {
// // // 	getAllCategories,
// // // 	getSelectedEventList,
// // // 	getSingleCategorySubproducts,
// // // } from '../../../../../services/api/MenuAPI';

// // // interface Category {
// // // 	_id: string;
// // // 	name: string;
// // // 	description: string;
// // // 	categoryImage: string;
// // // 	tag: string[];
// // // }

// // // interface MenuType {
// // // 	menuType: string;
// // // 	menuItems: {
// // // 		Items: string[];
// // // 	};
// // // 	numberOfPersons: number;
// // // }

// // // interface SelectedMenu {
// // // 	[key: string]: { category: string; item: string }[];
// // // }

// // // const CateringMenu: React.FC = () => {
// // // 	const [open, setOpen] = useState(false);
// // // 	const [activeCategory, setActiveCategory] = useState<string>('');
// // // 	const [activeMenuType, setActiveMenuType] = useState<string>('');
// // // 	const [subItems, setSubItems] = useState<string[]>([]);
// // // 	const [selectedMenu, setSelectedMenu] = useState<SelectedMenu>({});
// // // 	const [selectedMenuId, setSelectedMenuId] = useState('');
// // // 	const [formOpen, setFormOpen] = useState(false);
// // // 	const [categories, setCategories] = useState<Category[]>([]);
// // // 	const [menuTypes, setMenuTypes] = useState<MenuType[]>([]);
// // // 	const [loading, setLoading] = useState(false);
// // // 	const navigate = useNavigate();

// // // 	const handleCategoryClick = async (category: string, menuType: string) => {
// // // 		try {
// // // 			const response = await getSingleCategorySubproducts(category);
// // // 			const subs = response?.data?.subcategories || [];
// // // 			setSubItems(subs.map((sub: any) => sub.subCategory));
// // // 			setActiveCategory(category);
// // // 			setActiveMenuType(menuType);
// // // 			setOpen(true);
// // // 		} catch (error) {
// // // 			console.error('Error fetching subcategories', error);
// // // 		}
// // // 	};

// // // 	const handleSubItemClick = (item: string) => {
// // // 		setSelectedMenu((prev) => {
// // // 			const currentMenu = prev[activeMenuType] || [];
// // // 			const alreadyExists = currentMenu.some(
// // // 				(menu) => menu.category === activeCategory && menu.item === item
// // // 			);
// // // 			if (alreadyExists) {
// // // 				return {
// // // 					...prev,
// // // 					[activeMenuType]: currentMenu.filter(
// // // 						(menu) => !(menu.category === activeCategory && menu.item === item)
// // // 					),
// // // 				};
// // // 			} else {
// // // 				return {
// // // 					...prev,
// // // 					[activeMenuType]: [...currentMenu, { category: activeCategory, item }],
// // // 				};
// // // 			}
// // // 		});
// // // 	};

// // // 	const handleRemoveItem = (menuType: string, index: number) => {
// // // 		setSelectedMenu((prev) => {
// // // 			const currentMenu = prev[menuType] || [];
// // // 			return {
// // // 				...prev,
// // // 				[menuType]: currentMenu.filter((_, i) => i !== index),
// // // 			};
// // // 		});
// // // 	};

// // // 	const hanldeCloseSelecteMenu = () => setOpen(false);

// // // 	// const handleSubmit = async () => {
// // // 	// 	const storedFormData = sessionStorage.getItem('quotationFormData');
// // // 	// 	if (storedFormData) {
// // // 	// 		const data = JSON.parse(storedFormData);
// // // 	// 		const submissionData = {
// // // 	// 			// ...formData,
// // // 	// 			name: data?.name,
// // // 	// 			email: data?.email,
// // // 	// 			mobile: data?.mobile,
// // // 	// 			eventType: selectedMenuId,
// // // 	// 			functionDate: data?.functionDate,
// // // 	// 			location: `${data?.address}, ${data?.area}`,
// // // 	// 			isDefaultMenu: false,
// // // 	// 			menuTypes: [
// // // 	// 				,
// // // 	// 				{
// // // 	// 					menuType: selectedMenu.keyof[0],
// // // 	// 					menuItems: selectedMenu[0].map((val) => val.item),
// // // 	// 					numberOfPersons: menuTypes[0].numberOfPersons,
// // // 	// 				},
// // // 	// 			],
// // // 	// 		};
// // // 	// 		// const

// // // 	// 		try {
// // // 	// 			setLoading(true);
// // // 	// 			console.log(selectedMenu, '============================>');
// // // 	// 			const response = await createQuotation(submissionData);
// // // 	// 			if (response.success) {
// // // 	// 				console.log('Quotation created successfully');
// // // 	// 				navigate('/menus');
// // // 	// 			} else if (response.isError) {
// // // 	// 				console.error('Error creating quotation:', response);
// // // 	// 			}
// // // 	// 		} catch (error) {
// // // 	// 			console.error('Error submitting form:', error);
// // // 	// 		} finally {
// // // 	// 			setLoading(false);
// // // 	// 		}
// // // 	// 	}
// // // 	// };

// // // 	const handleSubmit = async () => {
// // // 		const storedFormData = sessionStorage.getItem('quotationFormData');
// // // 		if (storedFormData) {
// // // 			const data = JSON.parse(storedFormData);
// // // 			const submissionData = {
// // // 				name: data?.name,
// // // 				email: data?.email,
// // // 				mobile: data?.mobile,
// // // 				eventType: selectedMenuId,
// // // 				functionDate: data?.functionDate,
// // // 				location: `${data?.address}, ${data?.area}`,
// // // 				isDefaultMenu: false,
// // // 				menuTypes: Object.keys(selectedMenu).map((menuType) => ({
// // // 					menuType: menuType,
// // // 					menuItems: { Items: selectedMenu[menuType].map((item) => item.item) },
// // // 					numberOfPersons:
// // // 						menuTypes.find((mt) => mt.menuType === menuType)?.numberOfPersons || 0,
// // // 				})),
// // // 			};

// // // 			try {
// // // 				setLoading(true);
// // // 				const response = await createQuotation(submissionData);
// // // 				if (response.success) {
// // // 					toast.success(response?.data?.message);
// // // 					sessionStorage.removeItem('quotationFormData');
// // // 					navigate('/menu');
// // // 				} else if (response.isError) {
// // // 					console.error('Error creating quotation:', response);
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error submitting form:', error);
// // // 			} finally {
// // // 				setLoading(false);
// // // 			}
// // // 		}
// // // 	};

// // // 	const handleClose = () => {
// // // 		setFormOpen(false);
// // // 	};

// // // 	const handleMenusByTypes = async (eventId?: string) => {
// // // 		if (eventId) {
// // // 			try {
// // // 				const response = await getSelectedEventList(eventId);
// // // 				if (response.success) {
// // // 					const menuData = response.data;
// // // 					setMenuTypes(
// // // 						menuData.menuTypeNames.map((menuType: string) => ({
// // // 							menuType,
// // // 							menuItems: { Items: [] },
// // // 							numberOfPersons: 0,
// // // 						}))
// // // 					);
// // // 					setCategories(menuData.categories);
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error fetching categories', error);
// // // 			}
// // // 		}
// // // 	};

// // // 	useEffect(() => {
// // // 		const fetchData = async () => {
// // // 			setFormOpen(true);
// // // 			try {
// // // 				const response = await getAllCategories();
// // // 				if (response.success) {
// // // 					const cats: Category[] = response?.data?.categories || [];
// // // 					setCategories(cats);
// // // 				} else if (response.isError) {
// // // 					console.log(response, 'Error message in the custom menu get all categories');
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error fetching categories', error);
// // // 			}
// // // 		};
// // // 		fetchData();
// // // 	}, []);

// // // 	return (
// // // 		<Box sx={{ p: { xs: 2, sm: 2, md: 4, lg: 4 } }}>
// // // 			<Typography
// // // 				variant="h4"
// // // 				display={'flex'}
// // // 				justifyContent={'flex-start'}
// // // 				align="center"
// // // 				gutterBottom
// // // 				className="mb-2"
// // // 			>
// // // 				<Button variant="text" color="secondary" startIcon={<ArrowBackIcon />}>
// // // 					Back
// // // 				</Button>
// // // 			</Typography>
// // // 			<Typography variant="h4" color="primary" align="center" gutterBottom className="mb-2">
// // // 				Build Your Ideal Menu
// // // 			</Typography>
// // // 			<Typography variant="h5" align="center" gutterBottom className="mb-4">
// // // 				Select from our delicious catering options to create the perfect meal for your
// // // 				event. After submission, you’ll receive a customized quote via email.
// // // 			</Typography>
// // // 			<Box sx={{ p: 4, pl: 2, pr: 2 }}>
// // // 				<Grid container spacing={2}>
// // // 					{menuTypes.map((menuType, index) => (
// // // 						<>
// // // 							<Grid size={{ xs: 12, sm: 12, md: 8, lg: 7 }}>
// // // 								<Box
// // // 									key={index}
// // // 									sx={{
// // // 										mb: 4,
// // // 										border: '1px solid #00000033',
// // // 										borderRadius: '10px',
// // // 										p: 2,
// // // 									}}
// // // 									width={'100%'}
// // // 									height={'300px'}
// // // 									maxHeight={'300px'}
// // // 								>
// // // 									<Typography variant="h6" gutterBottom>
// // // 										{menuType.menuType}
// // // 									</Typography>
// // // 									<Grid container spacing={2}>
// // // 										{categories
// // // 											.filter((cat) => cat.tag.includes(menuType.menuType))
// // // 											.map((cat) => (
// // // 												<Grid key={cat.name}>
// // // 													<Button
// // // 														variant="contained"
// // // 														color="primary"
// // // 														onClick={() =>
// // // 															handleCategoryClick(
// // // 																cat.name,
// // // 																menuType.menuType
// // // 															)
// // // 														}
// // // 													>
// // // 														{cat.name}
// // // 													</Button>
// // // 												</Grid>
// // // 											))}
// // // 									</Grid>
// // // 								</Box>
// // // 							</Grid>
// // // 							<Grid size={{ xs: 12, sm: 12, md: 4, lg: 5 }}>
// // // 								<Box
// // // 									key={index}
// // // 									sx={{
// // // 										mb: 4,
// // // 										border: '1px solid #00000033',
// // // 										borderRadius: '10px',
// // // 										p: 2,
// // // 									}}
// // // 								>
// // // 									<Typography variant="h6" gutterBottom>
// // // 										{menuType.menuType}
// // // 									</Typography>
// // // 									<Grid container spacing={2}>
// // // 										<Box width={'100%'} height={'200px'} maxHeight={'250px'}>
// // // 											{!selectedMenu[menuType.menuType] ||
// // // 											selectedMenu[menuType.menuType].length === 0 ? (
// // // 												<Typography color="text.secondary">
// // // 													No items selected yet.
// // // 												</Typography>
// // // 											) : (
// // // 												// <Grid container spacing={1}>
// // // 												<Box sx={{ overflowY: 'auto' }} maxHeight={'220px'}>
// // // 													{selectedMenu[menuType.menuType].map(
// // // 														(item, index) => (
// // // 															// <Grid key={index}>
// // // 															<Chip
// // // 																key={index}
// // // 																label={`${item.item}`}
// // // 																onDelete={() =>
// // // 																	handleRemoveItem(
// // // 																		menuType.menuType,
// // // 																		index
// // // 																	)
// // // 																}
// // // 																className="m-1"
// // // 																color="secondary"
// // // 															/>
// // // 														)
// // // 													)}
// // // 												</Box>
// // // 												// </Grid>
// // // 											)}
// // // 											<TextField
// // // 												size="small"
// // // 												label="Number of People"
// // // 												type="number"
// // // 												fullWidth
// // // 												required
// // // 												sx={{ mt: 2 }}
// // // 												value={menuType.numberOfPersons}
// // // 												onChange={(e) => {
// // // 													const value = parseInt(e.target.value, 10);
// // // 													setMenuTypes((prev) =>
// // // 														prev.map((menu, i) =>
// // // 															i === index
// // // 																? {
// // // 																		...menu,
// // // 																		numberOfPersons: value,
// // // 																	}
// // // 																: menu
// // // 														)
// // // 													);
// // // 												}}
// // // 											/>
// // // 										</Box>
// // // 									</Grid>
// // // 								</Box>
// // // 							</Grid>
// // // 						</>
// // // 					))}
// // // 				</Grid>
// // // 			</Box>

// // // 			<Dialog open={open} onClose={hanldeCloseSelecteMenu} fullWidth>
// // // 				<DialogTitle>
// // // 					Select {activeCategory} Options{' '}
// // // 					<IconButton
// // // 						aria-label="close"
// // // 						onClick={hanldeCloseSelecteMenu}
// // // 						sx={{ position: 'absolute', right: 8, top: 8 }}
// // // 					>
// // // 						<CloseIcon />
// // // 					</IconButton>
// // // 				</DialogTitle>
// // // 				<DialogContent>
// // // 					<Grid container spacing={2} sx={{ mt: 1 }}>
// // // 						{subItems.map((item) => {
// // // 							const isSelected = selectedMenu[activeMenuType]?.some(
// // // 								(menu) => menu.category === activeCategory && menu.item === item
// // // 							);
// // // 							return (
// // // 								<Grid key={item}>
// // // 									<Button
// // // 										variant={isSelected ? 'contained' : 'outlined'}
// // // 										color={isSelected ? 'primary' : 'secondary'}
// // // 										onClick={() => handleSubItemClick(item)}
// // // 									>
// // // 										{item}
// // // 									</Button>
// // // 								</Grid>
// // // 							);
// // // 						})}
// // // 					</Grid>
// // // 				</DialogContent>
// // // 				<DialogActions>
// // // 					<Button onClick={() => setOpen(false)}>Close</Button>
// // // 				</DialogActions>
// // // 			</Dialog>

// // // 			<Button
// // // 				variant="contained"
// // // 				color="primary"
// // // 				onClick={handleSubmit}
// // // 				loading={loading}
// // // 				loadingIndicator="sending..."
// // // 			>
// // // 				Get Quotation
// // // 			</Button>
// // // 			<GetQuotationForm
// // // 				open={formOpen}
// // // 				handleClose={handleClose}
// // // 				onEventIdChange={(eventId) => {
// // // 					handleMenusByTypes(eventId);
// // // 					setSelectedMenuId(eventId);
// // // 				}}
// // // 			/>
// // // 			<ToastContainer />
// // // 		</Box>
// // // 	);
// // // };

// // // export default CateringMenu;
// // // =============================================================================================================================
// // // =============================================================================================================================
// // // =============================================================================================================================
// // // =============================================================================================================================
// // // =============================================================================================================================
// // // =============================================================================================================================
// // // import React, { useState, useEffect } from 'react';
// // // import { ToastContainer } from 'react-toastify';
// // // import {
// // // 	Box,
// // // 	Button,
// // // 	Grid,
// // // 	Typography,
// // // 	Chip,
// // // 	Dialog,
// // // 	DialogTitle,
// // // 	DialogContent,
// // // 	DialogActions,
// // // 	IconButton,
// // // 	TextField,
// // // 	Avatar,
// // // } from '@mui/material';
// // // import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // import CloseIcon from '@mui/icons-material/Close';
// // // import { useNavigate } from 'react-router-dom';
// // // import Swal from 'sweetalert2';
// // // import GetQuotationForm from './GetQuotationForm';
// // // import { createQuotation } from '../../../../../services/api/QuoationAPI';
// // // import {
// // // 	getAllCategories,
// // // 	getSelectedEventList,
// // // 	getSingleCategorySubproducts,
// // // } from '../../../../../services/api/MenuAPI';

// // // interface Category {
// // // 	_id: string;
// // // 	name: string;
// // // 	description: string;
// // // 	categoryImage: string;
// // // 	tag: string[];
// // // }

// // // interface MenuType {
// // // 	menuType: string;
// // // 	menuItems: {
// // // 		Items: string[];
// // // 	};
// // // 	numberOfPersons: number;
// // // }

// // // interface SubItem {
// // // 	subCategory: string;
// // // 	subCategoryImage: string;
// // // }

// // // interface SelectedMenu {
// // // 	[key: string]: { category: string; item: string }[];
// // // }

// // // const CateringMenu: React.FC = () => {
// // // 	const [open, setOpen] = useState(false);
// // // 	const [activeCategory, setActiveCategory] = useState<string>('');
// // // 	const [activeMenuType, setActiveMenuType] = useState<string>('');
// // // 	const [subItems, setSubItems] = useState<SubItem[]>([]);
// // // 	const [selectedMenu, setSelectedMenu] = useState<SelectedMenu>({});
// // // 	const [selectedMenuId, setSelectedMenuId] = useState('');
// // // 	const [formOpen, setFormOpen] = useState(false);
// // // 	const [categories, setCategories] = useState<Category[]>([]);
// // // 	const [menuTypes, setMenuTypes] = useState<MenuType[]>([]);
// // // 	const [loading, setLoading] = useState(false);
// // // 	const navigate = useNavigate();

// // // 	const handleCategoryClick = async (category: string, menuType: string) => {
// // // 		try {
// // // 			const response = await getSingleCategorySubproducts(category);
// // // 			const subs = response?.data?.subcategories || [];
// // // 			setSubItems(
// // // 				subs.map((sub: any) => ({
// // // 					subCategory: sub.subCategory,
// // // 					subCategoryImage: sub.subCategoryImage,
// // // 				}))
// // // 			);
// // // 			setActiveCategory(category);
// // // 			setActiveMenuType(menuType);
// // // 			setOpen(true);
// // // 		} catch (error) {
// // // 			console.error('Error fetching subcategories', error);
// // // 		}
// // // 	};

// // // 	const handleSubItemClick = (item: string) => {
// // // 		setSelectedMenu((prev) => {
// // // 			const currentMenu = prev[activeMenuType] || [];
// // // 			const alreadyExists = currentMenu.some(
// // // 				(menu) => menu.category === activeCategory && menu.item === item
// // // 			);
// // // 			if (alreadyExists) {
// // // 				return {
// // // 					...prev,
// // // 					[activeMenuType]: currentMenu.filter(
// // // 						(menu) => !(menu.category === activeCategory && menu.item === item)
// // // 					),
// // // 				};
// // // 			} else {
// // // 				return {
// // // 					...prev,
// // // 					[activeMenuType]: [...currentMenu, { category: activeCategory, item }],
// // // 				};
// // // 			}
// // // 		});
// // // 	};

// // // 	const handleRemoveItem = (menuType: string, index: number) => {
// // // 		setSelectedMenu((prev) => {
// // // 			const currentMenu = prev[menuType] || [];
// // // 			return {
// // // 				...prev,
// // // 				[menuType]: currentMenu.filter((_, i) => i !== index),
// // // 			};
// // // 		});
// // // 	};

// // // 	const hanldeCloseSelecteMenu = () => setOpen(false);

// // // 	const handleSubmit = async () => {
// // // 		const storedFormData = sessionStorage.getItem('quotationFormData');
// // // 		if (storedFormData) {
// // // 			const data = JSON.parse(storedFormData);
// // // 			const submissionData = {
// // // 				name: data?.name,
// // // 				email: data?.email,
// // // 				mobile: data?.mobile,
// // // 				eventType: selectedMenuId,
// // // 				functionDate: data?.functionDate,
// // // 				location: `${data?.address}, ${data?.area}`,
// // // 				isDefaultMenu: false,
// // // 				menuTypes: Object.keys(selectedMenu).map((menuType) => ({
// // // 					menuType: menuType,
// // // 					menuItems: { Items: selectedMenu[menuType].map((item) => item.item) },
// // // 					numberOfPersons:
// // // 						menuTypes.find((mt) => mt.menuType === menuType)?.numberOfPersons || 0,
// // // 				})),
// // // 			};

// // // 			try {
// // // 				setLoading(true);
// // // 				const response = await createQuotation(submissionData);
// // // 				if (response.success) {
// // // 					// toast.success(response?.data?.message);
// // // 					Swal.fire({
// // // 						icon: 'success',
// // // 						title: 'Thank you!',
// // // 						text: `${response?.data?.message}`,
// // // 						showConfirmButton: true,
// // // 						customClass: {
// // // 							popup: 'poppins-font',
// // // 						},
// // // 						backdrop: `rgba(0,0,0,0.4) left top no-repeat`,
// // // 						background: '#fff',
// // // 					});
// // // 					sessionStorage.removeItem('quotationFormData');
// // // 					setTimeout(() => {
// // // 						navigate('/menu');
// // // 					}, 4000);
// // // 				} else if (response.isError) {
// // // 					console.error('Error creating quotation:', response);
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error submitting form:', error);
// // // 			} finally {
// // // 				setLoading(false);
// // // 			}
// // // 		}
// // // 	};

// // // 	const handleClose = () => {
// // // 		setFormOpen(false);
// // // 	};

// // // 	const handleMenusByTypes = async (eventId?: string) => {
// // // 		if (eventId) {
// // // 			try {
// // // 				const response = await getSelectedEventList(eventId);
// // // 				if (response.success) {
// // // 					const menuData = response.data;
// // // 					setMenuTypes(
// // // 						menuData.menuTypeNames.map((menuType: string) => ({
// // // 							menuType,
// // // 							menuItems: { Items: [] },
// // // 							numberOfPersons: 0,
// // // 						}))
// // // 					);
// // // 					setCategories(menuData.categories);
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error fetching categories', error);
// // // 			}
// // // 		}
// // // 	};

// // // 	useEffect(() => {
// // // 		const fetchData = async () => {
// // // 			setFormOpen(true);
// // // 			try {
// // // 				const response = await getAllCategories();
// // // 				if (response.success) {
// // // 					const cats: Category[] = response?.data?.categories || [];
// // // 					setCategories(cats);
// // // 				} else if (response.isError) {
// // // 					console.log(response, 'Error message in the custom menu get all categories');
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error fetching categories', error);
// // // 			}
// // // 		};
// // // 		fetchData();
// // // 	}, []);

// // // 	return (
// // // 		<Box sx={{ p: { xs: 2, sm: 2, md: 4, lg: 4 } }}>
// // // 			<Typography
// // // 				variant="h4"
// // // 				display={'flex'}
// // // 				justifyContent={'flex-start'}
// // // 				align="center"
// // // 				gutterBottom
// // // 				className="mb-2"
// // // 			>
// // // 				<Button variant="text" color="secondary" startIcon={<ArrowBackIcon />}>
// // // 					Back
// // // 				</Button>
// // // 			</Typography>
// // // 			<Typography variant="h4" color="primary" align="center" gutterBottom className="mb-2">
// // // 				Build Your Ideal Menu
// // // 			</Typography>
// // // 			<Typography variant="h5" align="center" gutterBottom className="mb-4">
// // // 				Select from our delicious catering options to create the perfect meal for your
// // // 				event. After submission, you’ll receive a customized quote via email.
// // // 			</Typography>
// // // 			<Box sx={{ p: 4, pl: 2, pr: 2 }}>
// // // 				<Grid container spacing={2}>
// // // 					{menuTypes.map((menuType, index) => (
// // // 						<>
// // // 							<Grid size={{ xs: 12, sm: 12, md: 8, lg: 7 }}>
// // // 								<Box
// // // 									key={index}
// // // 									sx={{
// // // 										// mb: 4,
// // // 										border: '1px solid #00000033',
// // // 										borderRadius: '10px',
// // // 										p: 2,
// // // 									}}
// // // 									width={'100%'}
// // // 									height={'300px'}
// // // 									maxHeight={'300px'}
// // // 								>
// // // 									<Typography variant="h5" gutterBottom>
// // // 										{menuType.menuType}
// // // 									</Typography>
// // // 									<Box
// // // 										sx={{
// // // 											overflowY: 'auto',
// // // 											height: '243px',
// // // 											padding: '0px 0px 5px 5px',
// // // 										}}
// // // 									>
// // // 										<Grid container spacing={2}>
// // // 											{categories
// // // 												.filter((cat) =>
// // // 													cat.tag.includes(menuType.menuType)
// // // 												)
// // // 												.map((cat) => (
// // // 													<Grid key={cat.name}>
// // // 														<Button
// // // 															variant="contained"
// // // 															color="primary"
// // // 															onClick={() =>
// // // 																handleCategoryClick(
// // // 																	cat.name,
// // // 																	menuType.menuType
// // // 																)
// // // 															}
// // // 															sx={{
// // // 																padding: '0px',
// // // 																paddingRight: '15px',
// // // 															}}
// // // 															startIcon={
// // // 																<Avatar
// // // 																	src={cat.categoryImage}
// // // 																	sx={{
// // // 																		width: 40,
// // // 																		height: 40,
// // // 																	}}
// // // 																/>
// // // 															}
// // // 															endIcon={<KeyboardArrowDownIcon />}
// // // 														>
// // // 															{cat.name}
// // // 														</Button>
// // // 													</Grid>
// // // 												))}
// // // 										</Grid>
// // // 									</Box>
// // // 								</Box>
// // // 							</Grid>
// // // 							<Grid size={{ xs: 12, sm: 12, md: 4, lg: 5 }}>
// // // 								<Box
// // // 									key={index}
// // // 									sx={{
// // // 										// mb: 4,
// // // 										border: '1px solid #00000033',
// // // 										borderRadius: '10px',
// // // 										p: 2,
// // // 									}}
// // // 									width={'100%'}
// // // 									height={'300px'}
// // // 									maxHeight={'300px'}
// // // 								>
// // // 									<Typography variant="h5" gutterBottom>
// // // 										{menuType.menuType}
// // // 									</Typography>
// // // 									<Grid container spacing={2}>
// // // 										<Box width={'100%'} height={'243px'} maxHeight={'243px'}>
// // // 											{!selectedMenu[menuType.menuType] ||
// // // 											selectedMenu[menuType.menuType].length === 0 ? (
// // // 												<Typography color="text.secondary">
// // // 													No items selected yet.
// // // 												</Typography>
// // // 											) : (
// // // 												// <Grid container spacing={1}>
// // // 												<Box sx={{ overflowY: 'auto' }} maxHeight={'180px'}>
// // // 													{selectedMenu[menuType.menuType].map(
// // // 														(item, index) => (
// // // 															// <Grid key={index}>
// // // 															<Chip
// // // 																key={index}
// // // 																label={`${item.item}`}
// // // 																onDelete={() =>
// // // 																	handleRemoveItem(
// // // 																		menuType.menuType,
// // // 																		index
// // // 																	)
// // // 																}
// // // 																className="m-1"
// // // 																color="secondary"
// // // 															/>
// // // 														)
// // // 													)}
// // // 												</Box>
// // // 												// </Grid>
// // // 											)}
// // // 											{/* <TextField
// // // 												size="small"
// // // 												label="Number of People"
// // // 												type="number"
// // // 												fullWidth
// // // 												required
// // // 												sx={{ mt: 2 }}
// // // 												value={menuType.numberOfPersons}
// // // 												slotProps={{
// // // 													htmlInput: {
// // // 														min: 1,
// // // 														max: 9,
// // // 													},
// // // 												}}
// // // 												onChange={(e) => {
// // // 													let value = parseInt(e.target.value, 10) || 1;
// // // 													value = Math.min(Math.max(value, 1), 9);

// // // 													setMenuTypes((prev) =>
// // // 														prev.map((menu, i) =>
// // // 															i === index
// // // 																? {
// // // 																		...menu,
// // // 																		numberOfPersons: value,
// // // 																	}
// // // 																: menu
// // // 														)
// // // 													);
// // // 												}}
// // // 											/> */}
// // // 											<TextField
// // // 												size="small"
// // // 												label="Number of People"
// // // 												type="number"
// // // 												fullWidth
// // // 												required
// // // 												sx={{ mt: 2 }}
// // // 												value={menuType.numberOfPersons}
// // // 												onChange={(e) => {
// // // 													// Parse the input as an integer to remove any leading zeros
// // // 													let value = parseInt(e.target.value, 10) || 1; // Default to 1 if NaN

// // // 													// Ensure the value is at least 1 (strip leading zeros automatically)
// // // 													value = Math.max(value, 1);

// // // 													setMenuTypes((prev) =>
// // // 														prev.map((menu, i) =>
// // // 															i === index
// // // 																? {
// // // 																		...menu,
// // // 																		numberOfPersons: value,
// // // 																	}
// // // 																: menu
// // // 														)
// // // 													);
// // // 												}}
// // // 											/>

// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											{/* <TextField
// // // 												color="secondary"
// // // 												fullWidth
// // // 												type="number"
// // // 												label="No of People"
// // // 												name="noOfPeople"
// // // 												value={menuType.numberOfPersons}
// // // 												onChange={(e) => {
// // // 													const value = e.target.value;

// // // 													// Allow any numeric input including empty
// // // 													if (/^\d*$/.test(value)) {
// // // 														setMenuTypes({
// // // 															prev.map((menu, i) =>
// // // 																i === index
// // // 																	? {
// // // 																			...menu,
// // // 																			numberOfPersons: value,
// // // 																		}
// // // 																	: menu
// // // 															)
// // // 														});
// // // 													}
// // // 												}}
// // // 												onBlur={() => {
// // // 													// When user leaves the field, enforce minimum of 50
// // // 													const numericValue = Number(
// // // 														menuType.numberOfPersons
// // // 													);

// // // 													if (
// // // 														menuType.numberOfPersons !== '' &&
// // // 														numericValue < 50
// // // 													) {
// // // 														setMenuTypes((prev) =>
// // // 															prev.map((menu, i) =>
// // // 																i === index
// // // 																	? {
// // // 																			...menu,
// // // 																			numberOfPersons: 50,
// // // 																		}
// // // 																	: menu
// // // 															)
// // // 														);
// // // 													}
// // // 												}}
// // // 												error={!!errors.numberOfPersons}
// // // 												helperText={errors.numberOfPersons}
// // // 												size="small"
// // // 												slotProps={{
// // // 													input: {
// // // 														sx: {
// // // 															fontSize: '14px',
// // // 														},
// // // 													},
// // // 												}}
// // // 											/> */}
// // // 										</Box>
// // // 									</Grid>
// // // 								</Box>
// // // 							</Grid>
// // // 						</>
// // // 					))}
// // // 				</Grid>
// // // 			</Box>

// // // 			<Dialog open={open} onClose={hanldeCloseSelecteMenu} fullWidth>
// // // 				<DialogTitle>
// // // 					Select {activeCategory} Options{' '}
// // // 					<IconButton
// // // 						aria-label="close"
// // // 						onClick={hanldeCloseSelecteMenu}
// // // 						sx={{ position: 'absolute', right: 8, top: 8 }}
// // // 					>
// // // 						<CloseIcon />
// // // 					</IconButton>
// // // 				</DialogTitle>
// // // 				<DialogContent>
// // // 					<Grid container spacing={2} sx={{ mt: 1 }}>
// // // 						{subItems.map((item) => {
// // // 							const isSelected = selectedMenu[activeMenuType]?.some(
// // // 								(menu) =>
// // // 									menu.category === activeCategory &&
// // // 									menu.item === item.subCategory
// // // 							);
// // // 							return (
// // // 								<Grid key={item.subCategory}>
// // // 									<Button
// // // 										variant={isSelected ? 'contained' : 'outlined'}
// // // 										color={isSelected ? 'primary' : 'secondary'}
// // // 										onClick={() => handleSubItemClick(item.subCategory)}
// // // 										sx={{
// // // 											padding: '0px',
// // // 											paddingRight: '15px',
// // // 										}}
// // // 										startIcon={
// // // 											<Avatar
// // // 												src={item.subCategoryImage}
// // // 												alt={item.subCategory}
// // // 												sx={{ width: 40, height: 40 }}
// // // 											/>
// // // 										}
// // // 									>
// // // 										{item.subCategory}
// // // 									</Button>
// // // 								</Grid>
// // // 							);
// // // 						})}
// // // 					</Grid>
// // // 				</DialogContent>

// // // 				<DialogActions>
// // // 					<Button onClick={() => setOpen(false)}>Close</Button>
// // // 				</DialogActions>
// // // 			</Dialog>

// // // 			<Box className="w-100 text-center">
// // // 				<Button
// // // 					variant="contained"
// // // 					color="primary"
// // // 					onClick={handleSubmit}
// // // 					loading={loading}
// // // 					loadingIndicator="sending..."
// // // 					className="w-50"
// // // 				>
// // // 					Get Quotation
// // // 				</Button>
// // // 			</Box>
// // // 			<GetQuotationForm
// // // 				open={formOpen}
// // // 				handleClose={handleClose}
// // // 				onEventIdChange={(eventId) => {
// // // 					handleMenusByTypes(eventId);
// // // 					setSelectedMenuId(eventId);
// // // 				}}
// // // 			/>
// // // 			<ToastContainer />
// // // 		</Box>
// // // 	);
// // // };

// // // export default CateringMenu;
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // ==============================================================================================================================================================
// // // import React, { useState, useEffect } from 'react';
// // // import { ToastContainer } from 'react-toastify';
// // // import {
// // // 	Box,
// // // 	Button,
// // // 	Grid,
// // // 	Typography,
// // // 	Chip,
// // // 	Dialog,
// // // 	DialogTitle,
// // // 	DialogContent,
// // // 	DialogActions,
// // // 	IconButton,
// // // 	TextField,
// // // 	Avatar,
// // // } from '@mui/material';
// // // import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// // // import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// // // import CloseIcon from '@mui/icons-material/Close';
// // // import { useNavigate } from 'react-router-dom';
// // // import Swal from 'sweetalert2';
// // // import GetQuotationForm from './GetQuotationForm';
// // // import { createQuotation } from '../../../../../services/api/QuoationAPI';
// // // import {
// // // 	getAllCategories,
// // // 	getSelectedEventList,
// // // 	getSingleCategorySubproducts,
// // // } from '../../../../../services/api/MenuAPI';

// // // interface Category {
// // // 	_id: string;
// // // 	name: string;
// // // 	description: string;
// // // 	categoryImage: string;
// // // 	tag: string[];
// // // }

// // // interface MenuType {
// // // 	menuType: string;
// // // 	menuItems: {
// // // 		Items: string[];
// // // 	};
// // // 	numberOfPersons: number;
// // // }

// // // interface SubItem {
// // // 	subCategory: string;
// // // 	subCategoryImage: string;
// // // }

// // // interface SelectedMenu {
// // // 	[key: string]: { category: string; item: string }[];
// // // }

// // // const CateringMenu: React.FC = () => {
// // // 	const [open, setOpen] = useState(false);
// // // 	const [activeCategory, setActiveCategory] = useState<string>('');
// // // 	const [activeMenuType, setActiveMenuType] = useState<string>('');
// // // 	const [subItems, setSubItems] = useState<SubItem[]>([]);
// // // 	const [selectedMenu, setSelectedMenu] = useState<SelectedMenu>({});
// // // 	const [selectedMenuId, setSelectedMenuId] = useState('');
// // // 	const [formOpen, setFormOpen] = useState(false);
// // // 	const [categories, setCategories] = useState<Category[]>([]);
// // // 	const [menuTypes, setMenuTypes] = useState<MenuType[]>([]);
// // // 	const [loading, setLoading] = useState(false);
// // // 	const navigate = useNavigate();

// // // 	const handleCategoryClick = async (category: string, menuType: string) => {
// // // 		try {
// // // 			const response = await getSingleCategorySubproducts(category);
// // // 			const subs = response?.data?.subcategories || [];
// // // 			setSubItems(
// // // 				subs.map((sub: any) => ({
// // // 					subCategory: sub.subCategory,
// // // 					subCategoryImage: sub.subCategoryImage,
// // // 				}))
// // // 			);
// // // 			setActiveCategory(category);
// // // 			setActiveMenuType(menuType);
// // // 			setOpen(true);
// // // 		} catch (error) {
// // // 			console.error('Error fetching subcategories', error);
// // // 		}
// // // 	};

// // // 	const handleSubItemClick = (item: string) => {
// // // 		setSelectedMenu((prev) => {
// // // 			const currentMenu = prev[activeMenuType] || [];
// // // 			const alreadyExists = currentMenu.some(
// // // 				(menu) => menu.category === activeCategory && menu.item === item
// // // 			);
// // // 			if (alreadyExists) {
// // // 				return {
// // // 					...prev,
// // // 					[activeMenuType]: currentMenu.filter(
// // // 						(menu) => !(menu.category === activeCategory && menu.item === item)
// // // 					),
// // // 				};
// // // 			} else {
// // // 				return {
// // // 					...prev,
// // // 					[activeMenuType]: [...currentMenu, { category: activeCategory, item }],
// // // 				};
// // // 			}
// // // 		});
// // // 	};

// // // 	const handleRemoveItem = (menuType: string, index: number) => {
// // // 		setSelectedMenu((prev) => {
// // // 			const currentMenu = prev[menuType] || [];
// // // 			return {
// // // 				...prev,
// // // 				[menuType]: currentMenu.filter((_, i) => i !== index),
// // // 			};
// // // 		});
// // // 	};

// // // 	const hanldeCloseSelecteMenu = () => setOpen(false);

// // // 	const handleSubmit = async () => {
// // // 		const storedFormData = sessionStorage.getItem('quotationFormData');
// // // 		if (storedFormData) {
// // // 			const data = JSON.parse(storedFormData);
// // // 			const submissionData = {
// // // 				name: data?.name,
// // // 				email: data?.email,
// // // 				mobile: data?.mobile,
// // // 				eventType: selectedMenuId,
// // // 				functionDate: data?.functionDate,
// // // 				location: `${data?.address}, ${data?.area}`,
// // // 				isDefaultMenu: false,
// // // 				menuTypes: Object.keys(selectedMenu).map((menuType) => ({
// // // 					menuType: menuType,
// // // 					menuItems: { Items: selectedMenu[menuType].map((item) => item.item) },
// // // 					numberOfPersons:
// // // 						menuTypes.find((mt) => mt.menuType === menuType)?.numberOfPersons || 0,
// // // 				})),
// // // 			};

// // // 			try {
// // // 				setLoading(true);
// // // 				const response = await createQuotation(submissionData);
// // // 				if (response.success) {
// // // 					// toast.success(response?.data?.message);
// // // 					Swal.fire({
// // // 						icon: 'success',
// // // 						title: 'Thank you!',
// // // 						text: `${response?.data?.message}`,
// // // 						showConfirmButton: true,
// // // 						customClass: {
// // // 							popup: 'poppins-font',
// // // 						},
// // // 						backdrop: `rgba(0,0,0,0.4) left top no-repeat`,
// // // 						background: '#fff',
// // // 					});
// // // 					sessionStorage.removeItem('quotationFormData');
// // // 					setTimeout(() => {
// // // 						navigate('/menu');
// // // 					}, 4000);
// // // 				} else if (response.isError) {
// // // 					console.error('Error creating quotation:', response);
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error submitting form:', error);
// // // 			} finally {
// // // 				setLoading(false);
// // // 			}
// // // 		}
// // // 	};

// // // 	const handleClose = () => {
// // // 		setFormOpen(false);
// // // 	};

// // // 	const handleMenusByTypes = async (eventId?: string) => {
// // // 		if (eventId) {
// // // 			try {
// // // 				const response = await getSelectedEventList(eventId);
// // // 				if (response.success) {
// // // 					const menuData = response.data;
// // // 					setMenuTypes(
// // // 						menuData.menuTypeNames.map((menuType: string) => ({
// // // 							menuType,
// // // 							menuItems: { Items: [] },
// // // 							numberOfPersons: 0,
// // // 						}))
// // // 					);
// // // 					setCategories(menuData.categories);
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error fetching categories', error);
// // // 			}
// // // 		}
// // // 	};

// // // 	useEffect(() => {
// // // 		const fetchData = async () => {
// // // 			setFormOpen(true);
// // // 			try {
// // // 				const response = await getAllCategories();
// // // 				if (response.success) {
// // // 					const cats: Category[] = response?.data?.categories || [];
// // // 					setCategories(cats);
// // // 				} else if (response.isError) {
// // // 					console.log(response, 'Error message in the custom menu get all categories');
// // // 				}
// // // 			} catch (error) {
// // // 				console.error('Error fetching categories', error);
// // // 			}
// // // 		};
// // // 		fetchData();
// // // 	}, []);

// // // 	return (
// // // 		<Box sx={{ p: { xs: 2, sm: 2, md: 4, lg: 4 } }}>
// // // 			<Typography
// // // 				variant="h4"
// // // 				display={'flex'}
// // // 				justifyContent={'flex-start'}
// // // 				align="center"
// // // 				gutterBottom
// // // 				className="mb-2"
// // // 			>
// // // 				<Button variant="text" color="secondary" startIcon={<ArrowBackIcon />}>
// // // 					Back
// // // 				</Button>
// // // 			</Typography>
// // // 			<Typography variant="h4" color="primary" align="center" gutterBottom className="mb-2">
// // // 				Build Your Ideal Menu
// // // 			</Typography>
// // // 			<Typography variant="h5" align="center" gutterBottom className="mb-4">
// // // 				Select from our delicious catering options to create the perfect meal for your
// // // 				event. After submission, you’ll receive a customized quote via email.
// // // 			</Typography>
// // // 			<Box sx={{ p: 4, pl: 2, pr: 2 }}>
// // // 				<Grid container spacing={2}>
// // // 					{menuTypes.map((menuType, index) => (
// // // 						<>
// // // 							<Grid size={{ xs: 12, sm: 12, md: 8, lg: 7 }}>
// // // 								<Box
// // // 									key={index}
// // // 									sx={{
// // // 										// mb: 4,
// // // 										border: '1px solid #00000033',
// // // 										borderRadius: '10px',
// // // 										p: 2,
// // // 									}}
// // // 									width={'100%'}
// // // 									height={'300px'}
// // // 									maxHeight={'300px'}
// // // 								>
// // // 									<Typography variant="h5" gutterBottom>
// // // 										{menuType.menuType}
// // // 									</Typography>
// // // 									<Box
// // // 										sx={{
// // // 											overflowY: 'auto',
// // // 											height: '243px',
// // // 											padding: '0px 0px 5px 5px',
// // // 										}}
// // // 									>
// // // 										<Grid container spacing={2}>
// // // 											{categories
// // // 												.filter((cat) =>
// // // 													cat.tag.includes(menuType.menuType)
// // // 												)
// // // 												.map((cat) => (
// // // 													<Grid key={cat.name}>
// // // 														<Button
// // // 															variant="contained"
// // // 															color="primary"
// // // 															onClick={() =>
// // // 																handleCategoryClick(
// // // 																	cat.name,
// // // 																	menuType.menuType
// // // 																)
// // // 															}
// // // 															sx={{
// // // 																padding: '0px',
// // // 																paddingRight: '15px',
// // // 															}}
// // // 															startIcon={
// // // 																<Avatar
// // // 																	src={cat.categoryImage}
// // // 																	sx={{
// // // 																		width: 40,
// // // 																		height: 40,
// // // 																	}}
// // // 																/>
// // // 															}
// // // 															endIcon={<KeyboardArrowDownIcon />}
// // // 														>
// // // 															{cat.name}
// // // 														</Button>
// // // 													</Grid>
// // // 												))}
// // // 										</Grid>
// // // 									</Box>
// // // 								</Box>
// // // 							</Grid>
// // // 							<Grid size={{ xs: 12, sm: 12, md: 4, lg: 5 }}>
// // // 								<Box
// // // 									key={index}
// // // 									sx={{
// // // 										// mb: 4,
// // // 										border: '1px solid #00000033',
// // // 										borderRadius: '10px',
// // // 										p: 2,
// // // 									}}
// // // 									width={'100%'}
// // // 									height={'300px'}
// // // 									maxHeight={'300px'}
// // // 								>
// // // 									<Typography variant="h5" gutterBottom>
// // // 										{menuType.menuType}
// // // 									</Typography>
// // // 									<Grid container spacing={2}>
// // // 										<Box width={'100%'} height={'243px'} maxHeight={'243px'}>
// // // 											{!selectedMenu[menuType.menuType] ||
// // // 											selectedMenu[menuType.menuType].length === 0 ? (
// // // 												<Typography color="text.secondary">
// // // 													No items selected yet.
// // // 												</Typography>
// // // 											) : (
// // // 												// <Grid container spacing={1}>
// // // 												<Box sx={{ overflowY: 'auto' }} maxHeight={'180px'}>
// // // 													{selectedMenu[menuType.menuType].map(
// // // 														(item, index) => (
// // // 															// <Grid key={index}>
// // // 															<Chip
// // // 																key={index}
// // // 																label={`${item.item}`}
// // // 																onDelete={() =>
// // // 																	handleRemoveItem(
// // // 																		menuType.menuType,
// // // 																		index
// // // 																	)
// // // 																}
// // // 																className="m-1"
// // // 																color="secondary"
// // // 															/>
// // // 														)
// // // 													)}
// // // 												</Box>
// // // 												// </Grid>
// // // 											)}
// // // 											{/* <TextField
// // // 												size="small"
// // // 												label="Number of People"
// // // 												type="number"
// // // 												fullWidth
// // // 												required
// // // 												sx={{ mt: 2 }}
// // // 												value={menuType.numberOfPersons}
// // // 												onChange={(e) => {
// // // 													// Parse the input as an integer to remove any leading zeros
// // // 													let value = parseInt(e.target.value, 10) || 1; // Default to 1 if NaN

// // // 													// Ensure the value is at least 1 (strip leading zeros automatically)
// // // 													value = Math.max(value, 1);

// // // 													setMenuTypes((prev) =>
// // // 														prev.map((menu, i) =>
// // // 															i === index
// // // 																? {
// // // 																		...menu,
// // // 																		numberOfPersons: value,
// // // 																	}
// // // 																: menu
// // // 														)
// // // 													);
// // // 												}}
// // // 											/> */}

// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											{/* ============================================================================ */}
// // // 											<TextField
// // // 												color="secondary"
// // // 												fullWidth
// // // 												type="number"
// // // 												label="No of People"
// // // 												name="numberOfPersons"
// // // 												value={menuType.numberOfPersons}
// // // 												onChange={(e) => {
// // // 													const value = e.target.value;

// // // 													// Allow any numeric input including empty
// // // 													if (/^\d*$/.test(value)) {
// // // 														setMenuTypes({
// // // 															prev.map((menu, i) =>
// // // 																i === index
// // // 																	? {
// // // 																			...menu,
// // // 																			numberOfPersons: value,
// // // 																		}
// // // 																	: menu
// // // 															)
// // // 														});
// // // 													}
// // // 												}}
// // // 												onBlur={() => {
// // // 													// When user leaves the field, enforce minimum of 50
// // // 													const numericValue = Number(
// // // 														menuType.numberOfPersons
// // // 													);

// // // 													if (
// // // 														menuType.numberOfPersons !== '' &&
// // // 														numericValue < 50
// // // 													) {
// // // 														setMenuTypes((prev) =>
// // // 															prev.map((menu, i) =>
// // // 																i === index
// // // 																	? {
// // // 																			...menu,
// // // 																			numberOfPersons: 50,
// // // 																		}
// // // 																	: menu
// // // 															)
// // // 														);
// // // 													}
// // // 												}}
// // // 												error={!!errors.numberOfPersons}
// // // 												helperText={errors.numberOfPersons}
// // // 												size="small"
// // // 												slotProps={{
// // // 													input: {
// // // 														sx: {
// // // 															fontSize: '14px',
// // // 														},
// // // 													},
// // // 												}}
// // // 											/>
// // // 										</Box>
// // // 									</Grid>
// // // 								</Box>
// // // 							</Grid>
// // // 						</>
// // // 					))}
// // // 				</Grid>
// // // 			</Box>

// // // 			<Dialog open={open} onClose={hanldeCloseSelecteMenu} fullWidth>
// // // 				<DialogTitle>
// // // 					Select {activeCategory} Options{' '}
// // // 					<IconButton
// // // 						aria-label="close"
// // // 						onClick={hanldeCloseSelecteMenu}
// // // 						sx={{ position: 'absolute', right: 8, top: 8 }}
// // // 					>
// // // 						<CloseIcon />
// // // 					</IconButton>
// // // 				</DialogTitle>
// // // 				<DialogContent>
// // // 					<Grid container spacing={2} sx={{ mt: 1 }}>
// // // 						{subItems.map((item) => {
// // // 							const isSelected = selectedMenu[activeMenuType]?.some(
// // // 								(menu) =>
// // // 									menu.category === activeCategory &&
// // // 									menu.item === item.subCategory
// // // 							);
// // // 							return (
// // // 								<Grid key={item.subCategory}>
// // // 									<Button
// // // 										variant={isSelected ? 'contained' : 'outlined'}
// // // 										color={isSelected ? 'primary' : 'secondary'}
// // // 										onClick={() => handleSubItemClick(item.subCategory)}
// // // 										sx={{
// // // 											padding: '0px',
// // // 											paddingRight: '15px',
// // // 										}}
// // // 										startIcon={
// // // 											<Avatar
// // // 												src={item.subCategoryImage}
// // // 												alt={item.subCategory}
// // // 												sx={{ width: 40, height: 40 }}
// // // 											/>
// // // 										}
// // // 									>
// // // 										{item.subCategory}
// // // 									</Button>
// // // 								</Grid>
// // // 							);
// // // 						})}
// // // 					</Grid>
// // // 				</DialogContent>

// // // 				<DialogActions>
// // // 					<Button onClick={() => setOpen(false)}>Close</Button>
// // // 				</DialogActions>
// // // 			</Dialog>

// // // 			<Box className="w-100 text-center">
// // // 				<Button
// // // 					variant="contained"
// // // 					color="primary"
// // // 					onClick={handleSubmit}
// // // 					loading={loading}
// // // 					loadingIndicator="sending..."
// // // 					className="w-50"
// // // 				>
// // // 					Get Quotation
// // // 				</Button>
// // // 			</Box>
// // // 			<GetQuotationForm
// // // 				open={formOpen}
// // // 				handleClose={handleClose}
// // // 				onEventIdChange={(eventId) => {
// // // 					handleMenusByTypes(eventId);
// // // 					setSelectedMenuId(eventId);
// // // 				}}
// // // 			/>
// // // 			<ToastContainer />
// // // 		</Box>
// // // 	);
// // // };

// // // export default CateringMenu;
// // // ============================================================================================================================
// // // ============================================================================================================================
// // // ============================================================================================================================
// // // ============================================================================================================================
// // // ============================================================================================================================
// // // ============================================================================================================================
// // // ============================================================================================================================
// // // ============================================================================================================================
// // // ============================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// // ========================================================================================================================================================
// import React, { useState, useEffect } from 'react';
// import { ToastContainer } from 'react-toastify';
// import {
// 	Box,
// 	Button,
// 	Grid,
// 	Typography,
// 	Chip,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	IconButton,
// 	TextField,
// 	Avatar,
// } from '@mui/material';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import CloseIcon from '@mui/icons-material/Close';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import GetQuotationForm from './GetQuotationForm';
// import { createQuotation } from '../../../../../services/api/QuoationAPI';
// import {
// 	getAllCategories,
// 	getSelectedEventList,
// 	getSingleCategorySubproducts,
// } from '../../../../../services/api/MenuAPI';

// interface Category {
// 	_id: string;
// 	name: string;
// 	description: string;
// 	categoryImage: string;
// 	tag: string[];
// }

// interface MenuType {
// 	menuType: string;
// 	menuItems: {
// 		Items: string[];
// 	};
// 	numberOfPersons: number | undefined;
// }

// interface SubItem {
// 	subCategory: string;
// 	subCategoryImage: string;
// }

// interface SelectedMenu {
// 	[key: string]: { category: string; item: string }[];
// }

// const CateringMenu: React.FC = () => {
// 	const [open, setOpen] = useState(false);
// 	const [activeCategory, setActiveCategory] = useState<string>('');
// 	const [activeMenuType, setActiveMenuType] = useState<string>('');
// 	const [subItems, setSubItems] = useState<SubItem[]>([]);
// 	const [selectedMenu, setSelectedMenu] = useState<SelectedMenu>({});
// 	const [selectedMenuId, setSelectedMenuId] = useState('');
// 	const [formOpen, setFormOpen] = useState(false);
// 	const [categories, setCategories] = useState<Category[]>([]);
// 	const [menuTypes, setMenuTypes] = useState<MenuType[]>([]);
// 	const [loading, setLoading] = useState(false);
// 	const [personErrors, setPersonErrors] = useState<{ [key: string]: string }>({});
// 	const [hasValidationErrors, setHasValidationErrors] = useState(false);
// 	const navigate = useNavigate();

// 	const validateNumberOfPersons = (value: number | undefined, menuType: string) => {
// 		if (value === undefined || value === null) {
// 			return 'Number of people is required';
// 		}
// 		if (value < 50) {
// 			return 'Please enter number of people (min. 50)';
// 		}
// 		return '';
// 	};

// 	const handleCategoryClick = async (category: string, menuType: string) => {
// 		try {
// 			const response = await getSingleCategorySubproducts(category);
// 			const subs = response?.data?.subcategories || [];
// 			setSubItems(
// 				subs.map((sub: any) => ({
// 					subCategory: sub.subCategory,
// 					subCategoryImage: sub.subCategoryImage,
// 				}))
// 			);
// 			setActiveCategory(category);
// 			setActiveMenuType(menuType);
// 			setOpen(true);
// 		} catch (error) {
// 			console.error('Error fetching subcategories', error);
// 		}
// 	};

// 	const handleSubItemClick = (item: string) => {
// 		setSelectedMenu((prev) => {
// 			const currentMenu = prev[activeMenuType] || [];
// 			const alreadyExists = currentMenu.some(
// 				(menu) => menu.category === activeCategory && menu.item === item
// 			);
// 			if (alreadyExists) {
// 				return {
// 					...prev,
// 					[activeMenuType]: currentMenu.filter(
// 						(menu) => !(menu.category === activeCategory && menu.item === item)
// 					),
// 				};
// 			} else {
// 				return {
// 					...prev,
// 					[activeMenuType]: [...currentMenu, { category: activeCategory, item }],
// 				};
// 			}
// 		});
// 	};

// 	const handleRemoveItem = (menuType: string, index: number) => {
// 		setSelectedMenu((prev) => {
// 			const currentMenu = prev[menuType] || [];
// 			return {
// 				...prev,
// 				[menuType]: currentMenu.filter((_, i) => i !== index),
// 			};
// 		});
// 	};

// 	const hanldeCloseSelecteMenu = () => setOpen(false);

// 	const handleSubmit = async () => {
// 		const storedFormData = sessionStorage.getItem('quotationFormData');
// 		let hasErrors = false;
// 		const newErrors: { [key: string]: string } = {};

// 		menuTypes.forEach((menu) => {
// 			const hasItems = selectedMenu[menu.menuType]?.length > 0;
// 			const error = validateNumberOfPersons(menu.numberOfPersons, menu.menuType);
// 			if (hasItems && error) {
// 				newErrors[menu.menuType] = error;
// 				hasErrors = true;
// 			}
// 		});

// 		if (hasErrors) {
// 			setPersonErrors(newErrors);
// 			setHasValidationErrors(true);
// 			return; // Stop submission
// 		}

// 		if (storedFormData) {
// 			const data = JSON.parse(storedFormData);
// 			const submissionData = {
// 				name: data?.name,
// 				email: data?.email,
// 				mobile: data?.mobile,
// 				eventType: selectedMenuId,
// 				functionDate: data?.functionDate,
// 				location: `${data?.address}, ${data?.area}`,
// 				isDefaultMenu: false,
// 				menuTypes: Object.keys(selectedMenu).map((menuType) => ({
// 					menuType: menuType,
// 					menuItems: { Items: selectedMenu[menuType].map((item) => item.item) },
// 					numberOfPersons:
// 						menuTypes.find((mt) => mt.menuType === menuType)?.numberOfPersons || 50,
// 				})),
// 			};

// 			try {
// 				setLoading(true);
// 				const response = await createQuotation(submissionData);
// 				if (response.success) {
// 					Swal.fire({
// 						icon: 'success',
// 						title: 'Thank you!',
// 						text: `${response?.data?.message}`,
// 						showConfirmButton: true,
// 						customClass: {
// 							popup: 'poppins-font',
// 						},
// 						backdrop: `rgba(0,0,0,0.4) left top no-repeat`,
// 						background: '#fff',
// 					});
// 					sessionStorage.removeItem('quotationFormData');
// 					setTimeout(() => {
// 						navigate('/menu');
// 					}, 4000);
// 				} else if (response.isError) {
// 					console.error('Error creating quotation:', response);
// 				}
// 			} catch (error) {
// 				console.error('Error submitting form:', error);
// 			} finally {
// 				setLoading(false);
// 			}
// 		}
// 	};

// 	const handleClose = () => {
// 		setFormOpen(false);
// 	};

// 	const handleMenusByTypes = async (eventId?: string) => {
// 		if (eventId) {
// 			try {
// 				const response = await getSelectedEventList(eventId);
// 				if (response.success) {
// 					const menuData = response.data;
// 					setMenuTypes(
// 						menuData.menuTypeNames.map((menuType: string) => ({
// 							menuType,
// 							menuItems: { Items: [] },
// 							numberOfPersons: 0,
// 						}))
// 					);
// 					setCategories(menuData.categories);
// 				}
// 			} catch (error) {
// 				console.error('Error fetching categories', error);
// 			}
// 		}
// 	};

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			setFormOpen(true);
// 			try {
// 				const response = await getAllCategories();
// 				if (response.success) {
// 					const cats: Category[] = response?.data?.categories || [];
// 					setCategories(cats);
// 				} else if (response.isError) {
// 					console.log(response, 'Error message in the custom menu get all categories');
// 				}
// 			} catch (error) {
// 				console.error('Error fetching categories', error);
// 			}
// 		};
// 		fetchData();
// 	}, []);

// 	useEffect(() => {
// 		// Check for validation errors whenever personErrors changes
// 		const hasErrors = Object.values(personErrors).some((error) => error !== '');
// 		setHasValidationErrors(hasErrors);
// 	}, [personErrors]);

// 	return (
// 		<Box sx={{ p: { xs: 2, sm: 2, md: 4, lg: 4 } }}>
// 			<Typography
// 				variant="h4"
// 				display={'flex'}
// 				justifyContent={'flex-start'}
// 				align="center"
// 				gutterBottom
// 				className="mb-2"
// 			>
// 				<Button variant="text" color="secondary" startIcon={<ArrowBackIcon />}>
// 					Back
// 				</Button>
// 			</Typography>
// 			<Typography variant="h4" color="primary" align="center" gutterBottom className="mb-2">
// 				Build Your Ideal Menu
// 			</Typography>
// 			<Typography variant="h5" align="center" gutterBottom className="mb-4">
// 				Select from our delicious catering options to create the perfect meal for your
// 				event. After submission, you’ll receive a customized quote via email.
// 			</Typography>
// 			<Box sx={{ p: 4, pl: 2, pr: 2 }}>
// 				<Grid container spacing={2}>
// 					{menuTypes.map((menuType, index) => (
// 						<>
// 							<Grid item xs={12} sm={12} md={8} lg={7}>
// 								<Box
// 									key={index}
// 									sx={{
// 										border: '1px solid #00000033',
// 										borderRadius: '10px',
// 										p: 2,
// 									}}
// 									width={'100%'}
// 									height={'300px'}
// 									maxHeight={'300px'}
// 								>
// 									<Typography variant="h5" gutterBottom>
// 										{menuType.menuType}
// 									</Typography>
// 									<Box
// 										sx={{
// 											overflowY: 'auto',
// 											height: '243px',
// 											padding: '0px 0px 5px 5px',
// 										}}
// 									>
// 										<Grid container spacing={2}>
// 											{categories
// 												.filter((cat) =>
// 													cat.tag.includes(menuType.menuType)
// 												)
// 												.map((cat) => (
// 													<Grid item key={cat.name}>
// 														<Button
// 															variant="contained"
// 															color="primary"
// 															onClick={() =>
// 																handleCategoryClick(
// 																	cat.name,
// 																	menuType.menuType
// 																)
// 															}
// 															sx={{
// 																padding: '0px',
// 																paddingRight: '15px',
// 															}}
// 															startIcon={
// 																<Avatar
// 																	src={cat.categoryImage}
// 																	sx={{
// 																		width: 40,
// 																		height: 40,
// 																	}}
// 																/>
// 															}
// 															endIcon={<KeyboardArrowDownIcon />}
// 														>
// 															{cat.name}
// 														</Button>
// 													</Grid>
// 												))}
// 										</Grid>
// 									</Box>
// 								</Box>
// 							</Grid>
// 							<Grid item xs={12} sm={12} md={4} lg={5}>
// 								<Box
// 									key={index}
// 									sx={{
// 										border: '1px solid #00000033',
// 										borderRadius: '10px',
// 										p: 2,
// 									}}
// 									width={'100%'}
// 									height={'300px'}
// 									maxHeight={'300px'}
// 								>
// 									<Typography variant="h5" gutterBottom>
// 										{menuType.menuType}
// 									</Typography>
// 									<Grid container spacing={2}>
// 										<Box width={'100%'} height={'243px'} maxHeight={'243px'}>
// 											{!selectedMenu[menuType.menuType] ||
// 											selectedMenu[menuType.menuType].length === 0 ? (
// 												<Typography color="text.secondary">
// 													No items selected yet.
// 												</Typography>
// 											) : (
// 												<Box sx={{ overflowY: 'auto' }} maxHeight={'180px'}>
// 													{selectedMenu[menuType.menuType].map(
// 														(item, index) => (
// 															<Chip
// 																key={index}
// 																label={`${item.item}`}
// 																onDelete={() =>
// 																	handleRemoveItem(
// 																		menuType.menuType,
// 																		index
// 																	)
// 																}
// 																className="m-1"
// 																color="secondary"
// 															/>
// 														)
// 													)}
// 												</Box>
// 											)}

// 											<TextField
// 												color="secondary"
// 												fullWidth
// 												label="No of People"
// 												name="numberOfPersons"
// 												value={
// 													menuType?.numberOfPersons !== undefined &&
// 													menuType?.numberOfPersons !== null
// 														? menuType.numberOfPersons.toString()
// 														: ''
// 												} // Ensure value is always a string
// 												error={!!personErrors[menuType.menuType]} // Show error if there's a validation error for the specific menuType
// 												helperText={personErrors[menuType.menuType]} // Display the validation error message
// 												onChange={(e) => {
// 													const value = e.target.value;
// 													const numericValue =
// 														value === ''
// 															? undefined
// 															: parseInt(value, 10);

// 													setMenuTypes((prev) =>
// 														prev.map((menu, i) =>
// 															i === index
// 																? {
// 																		...menu,
// 																		numberOfPersons:
// 																			numericValue,
// 																	}
// 																: menu
// 														)
// 													);

// 													const error = validateNumberOfPersons(
// 														numericValue,
// 														menuType.menuType
// 													);
// 													setPersonErrors((prev) => ({
// 														...prev,
// 														[menuType.menuType]: error,
// 													}));
// 												}}
// 												size="small"
// 												className="mt-3"
// 												slotProps={{
// 													input: {
// 														sx: {
// 															fontSize: '14px',
// 														},
// 													},
// 												}}
// 											/>
// 										</Box>
// 									</Grid>
// 								</Box>
// 							</Grid>
// 						</>
// 					))}
// 				</Grid>
// 			</Box>

// 			<Dialog open={open} onClose={hanldeCloseSelecteMenu} fullWidth>
// 				<DialogTitle>
// 					Select {activeCategory} Options{' '}
// 					<IconButton
// 						aria-label="close"
// 						onClick={hanldeCloseSelecteMenu}
// 						sx={{ position: 'absolute', right: 8, top: 8 }}
// 					>
// 						<CloseIcon />
// 					</IconButton>
// 				</DialogTitle>
// 				<DialogContent>
// 					<Grid container spacing={2} sx={{ mt: 1 }}>
// 						{subItems.map((item) => {
// 							const isSelected = selectedMenu[activeMenuType]?.some(
// 								(menu) =>
// 									menu.category === activeCategory &&
// 									menu.item === item.subCategory
// 							);
// 							return (
// 								<Grid item key={item.subCategory}>
// 									<Button
// 										variant={isSelected ? 'contained' : 'outlined'}
// 										color={isSelected ? 'primary' : 'secondary'}
// 										onClick={() => handleSubItemClick(item.subCategory)}
// 										sx={{
// 											padding: '0px',
// 											paddingRight: '15px',
// 										}}
// 										startIcon={
// 											<Avatar
// 												src={item.subCategoryImage}
// 												alt={item.subCategory}
// 												sx={{ width: 40, height: 40 }}
// 											/>
// 										}
// 									>
// 										{item.subCategory}
// 									</Button>
// 								</Grid>
// 							);
// 						})}
// 					</Grid>
// 				</DialogContent>

// 				<DialogActions>
// 					<Button onClick={() => setOpen(false)}>Close</Button>
// 				</DialogActions>
// 			</Dialog>

// 			<Box className="w-100 text-center">
// 				<Button
// 					variant="contained"
// 					color="primary"
// 					onClick={handleSubmit}
// 					disabled={loading || hasValidationErrors}
// 					className="w-50"
// 				>
// 					Get Quotation
// 				</Button>
// 				{hasValidationErrors && (
// 					<Typography color="error" className="mt-2">
// 						Please fix the errors above before submitting.
// 					</Typography>
// 				)}
// 			</Box>
// 			<GetQuotationForm
// 				open={formOpen}
// 				handleClose={handleClose}
// 				onEventIdChange={(eventId) => {
// 					handleMenusByTypes(eventId);
// 					setSelectedMenuId(eventId);
// 				}}
// 			/>
// 			<ToastContainer />
// 		</Box>
// 	);
// };

// export default CateringMenu;
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
// ============================================================================================================================================================
import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import {
	Box,
	Button,
	Grid,
	Typography,
	Chip,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	TextField,
	Avatar,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import GetQuotationForm from './GetQuotationForm';
import { createQuotation } from '../../../../../services/api/QuoationAPI';
import {
	getAllCategories,
	getSelectedEventList,
	getSingleCategorySubproducts,
} from '../../../../../services/api/MenuAPI';

interface Category {
	_id: string;
	name: string;
	description: string;
	categoryImage: string;
	tag: string[];
}

interface MenuType {
	menuType: string;
	menuItems: {
		Items: string[];
	};
	numberOfPersons: number | undefined;
}

interface SubItem {
	subCategory: string;
	subCategoryImage: string;
}

interface SelectedMenu {
	[key: string]: { category: string; item: string }[];
}

const CateringMenu: React.FC = () => {
	const [open, setOpen] = useState(false);
	const [activeCategory, setActiveCategory] = useState<string>('');
	const [activeMenuType, setActiveMenuType] = useState<string>('');
	const [subItems, setSubItems] = useState<SubItem[]>([]);
	const [selectedMenu, setSelectedMenu] = useState<SelectedMenu>({});
	const [selectedMenuId, setSelectedMenuId] = useState('');
	const [formOpen, setFormOpen] = useState(false);
	const [categories, setCategories] = useState<Category[]>([]);
	const [menuTypes, setMenuTypes] = useState<MenuType[]>([]);
	const [loading, setLoading] = useState(false);
	const [personErrors, setPersonErrors] = useState<{ [key: string]: string }>({});
	const [hasValidationErrors, setHasValidationErrors] = useState(false);
	const navigate = useNavigate();
	const validateNumberOfPersons = (value: number | undefined): string => {
		if (value === undefined || isNaN(value)) {
			return 'Number of people is required';
		}
		if (value < 50) {
			return 'Please enter number of people (min. 50)';
		}
		return '';
	};

	const handleBackClick = () => {
		navigate('/menu');
	};
	const handleCategoryClick = async (category: string, menuType: string) => {
		try {
			const response = await getSingleCategorySubproducts(category);
			const subs = response?.data?.subcategories || [];
			setSubItems(
				subs.map((sub: any) => ({
					subCategory: sub.subCategory,
					subCategoryImage: sub.subCategoryImage,
				}))
			);
			setActiveCategory(category);
			setActiveMenuType(menuType);
			setOpen(true);
		} catch (error) {
			console.error('Error fetching subcategories', error);
		}
	};

	const handleSubItemClick = (item: string) => {
		setSelectedMenu((prev) => {
			const currentMenu = prev[activeMenuType] || [];
			const alreadyExists = currentMenu.some(
				(menu) => menu.category === activeCategory && menu.item === item
			);
			if (alreadyExists) {
				return {
					...prev,
					[activeMenuType]: currentMenu.filter(
						(menu) => !(menu.category === activeCategory && menu.item === item)
					),
				};
			} else {
				return {
					...prev,
					[activeMenuType]: [...currentMenu, { category: activeCategory, item }],
				};
			}
		});
	};

	const handleRemoveItem = (menuType: string, index: number) => {
		setSelectedMenu((prev) => {
			const currentMenu = prev[menuType] || [];
			return {
				...prev,
				[menuType]: currentMenu.filter((_, i) => i !== index),
			};
		});
	};

	const hanldeCloseSelecteMenu = () => setOpen(false);

	const handleSubmit = async () => {
		const storedFormData = sessionStorage.getItem('quotationFormData');
		let hasErrors = false;
		const newErrors: { [key: string]: string } = {};

		menuTypes.forEach((menu) => {
			const hasItems = selectedMenu[menu.menuType]?.length > 0;
			// const error = validateNumberOfPersons(menu.numberOfPersons, menu.menuType);
			const error = validateNumberOfPersons(menu.numberOfPersons);
			if (hasItems && error) {
				newErrors[menu.menuType] = error;
				hasErrors = true;
			}
		});

		if (hasErrors) {
			setPersonErrors(newErrors);
			setHasValidationErrors(true);
			return; // Stop submission
		}

		if (storedFormData) {
			const data = JSON.parse(storedFormData);
			const submissionData = {
				name: data?.name,
				email: data?.email,
				mobile: data?.mobile,
				eventType: selectedMenuId,
				functionDate: data?.functionDate,
				location: `${data?.address}, ${data?.area}`,
				isDefaultMenu: false,
				menuTypes: Object.keys(selectedMenu).map((menuType) => ({
					menuType: menuType,
					menuItems: { Items: selectedMenu[menuType].map((item) => item.item) },
					numberOfPersons:
						menuTypes.find((mt) => mt.menuType === menuType)?.numberOfPersons || 50,
				})),
			};

			try {
				setLoading(true);
				const response = await createQuotation(submissionData);
				if (response.success) {
					Swal.fire({
						icon: 'success',
						title: 'Thank you!',
						text: `${response?.data?.message}`,
						showConfirmButton: true,
						customClass: {
							popup: 'poppins-font',
						},
						backdrop: `rgba(0,0,0,0.4) left top no-repeat`,
						background: '#fff',
					});
					sessionStorage.removeItem('quotationFormData');
					setTimeout(() => {
						navigate('/menu');
					}, 4000);
				} else if (response.isError) {
					console.error('Error creating quotation:', response);
				}
			} catch (error) {
				console.error('Error submitting form:', error);
			} finally {
				setLoading(false);
			}
		}
	};

	const handleClose = () => {
		setFormOpen(false);
	};

	const handleMenusByTypes = async (eventId?: string) => {
		if (eventId) {
			try {
				const response = await getSelectedEventList(eventId);
				if (response.success) {
					const menuData = response.data;
					setMenuTypes(
						menuData.menuTypeNames.map((menuType: string) => ({
							menuType,
							menuItems: { Items: [] },
							numberOfPersons: 50,
						}))
					);
					setCategories(menuData.categories);
				}
			} catch (error) {
				console.error('Error fetching categories', error);
			}
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			setFormOpen(true);
			try {
				const response = await getAllCategories();
				if (response.success) {
					const cats: Category[] = response?.data?.categories || [];
					setCategories(cats);
				} else if (response.isError) {
					console.log(response, 'Error message in the custom menu get all categories');
				}
			} catch (error) {
				console.error('Error fetching categories', error);
			}
		};
		fetchData();
	}, []);

	useEffect(() => {
		// Check for validation errors whenever personErrors changes
		const hasErrors = Object.values(personErrors).some((error) => error !== '');
		setHasValidationErrors(hasErrors);
	}, [personErrors]);
	console.log(selectedMenu, '================>');
	return (
		<Box sx={{ p: { xs: 2, sm: 2, md: 4, lg: 4 } }}>
			<Typography
				variant="h4"
				display={'flex'}
				justifyContent={'flex-start'}
				align="center"
				gutterBottom
				className="mb-2"
			>
				<Button
					variant="text"
					color="secondary"
					startIcon={<ArrowBackIcon />}
					onClick={handleBackClick}
				>
					Back
				</Button>
			</Typography>
			<Typography variant="h4" color="primary" align="center" gutterBottom className="mb-2">
				Build Your Ideal Menu
			</Typography>
			<Typography variant="h5" align="center" gutterBottom className="mb-4">
				Select from our delicious catering options to create the perfect meal for your
				event. After submission, you’ll receive a customized quote via email.
			</Typography>
			<Box sx={{ p: 4, pl: 2, pr: 2 }}>
				<Grid container spacing={2}>
					{menuTypes.map((menuType, index) => (
						<>
							<Grid size={{ xs: 12, sm: 12, md: 8, lg: 7 }}>
								<Box
									key={index}
									sx={{
										border: '1px solid #00000033',
										borderRadius: '10px',
										p: 2,
									}}
									width={'100%'}
									height={'300px'}
									maxHeight={'300px'}
								>
									<Typography variant="h5" gutterBottom>
										{menuType.menuType}
									</Typography>
									<Box
										sx={{
											overflowY: 'auto',
											height: '243px',
											padding: '0px 0px 5px 5px',
										}}
									>
										<Grid container spacing={2}>
											{categories
												.filter((cat) =>
													cat.tag.includes(menuType.menuType)
												)
												.map((cat) => (
													<Grid key={cat.name}>
														<Button
															variant="contained"
															color="primary"
															onClick={() =>
																handleCategoryClick(
																	cat.name,
																	menuType.menuType
																)
															}
															sx={{
																padding: '0px',
																paddingRight: '15px',
															}}
															startIcon={
																<Avatar
																	src={cat.categoryImage}
																	sx={{
																		width: 40,
																		height: 40,
																	}}
																/>
															}
															endIcon={<KeyboardArrowDownIcon />}
														>
															{cat.name}
														</Button>
													</Grid>
												))}
										</Grid>
									</Box>
								</Box>
							</Grid>
							<Grid size={{ xs: 12, sm: 12, md: 4, lg: 5 }}>
								<Box
									key={index}
									sx={{
										border: '1px solid #00000033',
										borderRadius: '10px',
										p: 2,
									}}
									width={'100%'}
									height={'300px'}
									maxHeight={'300px'}
								>
									<Typography variant="h5" gutterBottom>
										{menuType.menuType}
									</Typography>
									<Grid container spacing={2}>
										<Box width={'100%'} height={'243px'} maxHeight={'243px'}>
											{!selectedMenu[menuType.menuType] ||
											selectedMenu[menuType.menuType].length === 0 ? (
												<Typography color="text.secondary">
													No items selected yet.
												</Typography>
											) : (
												<Box sx={{ overflowY: 'auto' }} maxHeight={'180px'}>
													{selectedMenu[menuType.menuType].map(
														(item, index) => (
															<Chip
																key={index}
																label={`${item.item}`}
																onDelete={() =>
																	handleRemoveItem(
																		menuType.menuType,
																		index
																	)
																}
																className="m-1"
																color="secondary"
															/>
														)
													)}
												</Box>
											)}

											{/* <TextField
												color="secondary"
												fullWidth
												label="No of People"
												name="numberOfPersons"
												value={
													menuType?.numberOfPersons
														? menuType.numberOfPersons.toString()
														: '50'
												} // Ensure value is always a string
												error={!!personErrors[menuType.menuType]} // Show error if there's a validation error for the specific menuType
												helperText={personErrors[menuType.menuType]} // Display the validation error message
												onChange={(e) => {
													const value = e.target.value;
													const numericValue =
														value === ''
															? undefined
															: parseInt(value, 10);

													setMenuTypes((prev) =>
														prev.map((menu, i) =>
															i === index
																? {
																		...menu,
																		numberOfPersons:
																			numericValue,
																	}
																: menu
														)
													);

													const error = validateNumberOfPersons(
														numericValue,
														menuType.menuType
													);
													setPersonErrors((prev) => ({
														...prev,
														[menuType.menuType]: error,
													}));
												}}
												size="small"
												className="mt-3"
												slotProps={{
													input: {
														sx: {
															fontSize: '14px',
														},
													},
												}}
											/> */}
											<TextField
												color="secondary"
												fullWidth
												type="number"
												label="No of People"
												name="numberOfPersons"
												value={
													// menuType.numberOfPersons !== undefined
													menuType.numberOfPersons
														? menuType.numberOfPersons.toString()
														: ''
												} // Allow empty
												error={!!personErrors[menuType.menuType]}
												helperText={personErrors[menuType.menuType]}
												onChange={(e) => {
													const value = e.target.value;

													// Convert to number or undefined
													const numericValue =
														value === ''
															? undefined
															: parseInt(value, 10);

													// Update state
													setMenuTypes((prev) =>
														prev.map((menu, i) =>
															i === index
																? {
																		...menu,
																		numberOfPersons:
																			numericValue,
																	}
																: menu
														)
													);

													// Validate
													const error =
														validateNumberOfPersons(numericValue);
													setPersonErrors((prev) => ({
														...prev,
														[menuType.menuType]: error,
													}));
												}}
												onBlur={() => {
													const value = menuType.numberOfPersons;
													const error = validateNumberOfPersons(value);

													if (error) {
														// Set error
														setPersonErrors((prev) => ({
															...prev,
															[menuType.menuType]: error,
														}));

														if (value === undefined || value < 50) {
															const correctedValue = 50;

															setMenuTypes((prev) =>
																prev.map((menu, i) =>
																	i === index
																		? {
																				...menu,
																				numberOfPersons:
																					correctedValue,
																			}
																		: menu
																)
															);

															const error =
																validateNumberOfPersons(
																	correctedValue
																);
															setPersonErrors((prev) => ({
																...prev,
																[menuType.menuType]: error,
															}));
														}
													}
												}}
												size="small"
												className="mt-3"
												variant="outlined"
												// slotProps={{
												// 	input: {
												// 		sx: {
												// 			fontSize: '14px',
												// 		},
												// 	},
												// }}
											/>
										</Box>
									</Grid>
								</Box>
							</Grid>
						</>
					))}
				</Grid>
			</Box>

			<Dialog open={open} onClose={hanldeCloseSelecteMenu} fullWidth>
				<DialogTitle>
					Select {activeCategory} Options{' '}
					<IconButton
						aria-label="close"
						onClick={hanldeCloseSelecteMenu}
						sx={{ position: 'absolute', right: 8, top: 8 }}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={2} sx={{ mt: 1 }}>
						{subItems.map((item) => {
							const isSelected = selectedMenu[activeMenuType]?.some(
								(menu) =>
									menu.category === activeCategory &&
									menu.item === item.subCategory
							);
							return (
								<Grid key={item.subCategory}>
									<Button
										variant={isSelected ? 'contained' : 'outlined'}
										color={isSelected ? 'primary' : 'secondary'}
										onClick={() => handleSubItemClick(item.subCategory)}
										sx={{
											padding: '0px',
											paddingRight: '15px',
										}}
										startIcon={
											<Avatar
												src={item.subCategoryImage}
												alt={item.subCategory}
												sx={{ width: 40, height: 40 }}
											/>
										}
									>
										{item.subCategory}
									</Button>
								</Grid>
							);
						})}
					</Grid>
				</DialogContent>

				<DialogActions>
					<Button onClick={() => setOpen(false)}>Close</Button>
				</DialogActions>
			</Dialog>

			<Box className="w-100 text-center">
				<Button
					variant="contained"
					color="primary"
					onClick={handleSubmit}
					disabled={
						loading || hasValidationErrors || Object.keys(selectedMenu).length === 0
					}
					className="w-50"
				>
					Get Quotation
				</Button>
				{hasValidationErrors && (
					<Typography color="error" className="mt-2">
						Please fix the errors above before submitting.
					</Typography>
				)}
				{Object.keys(selectedMenu).length === 0 && (
					<Typography color="error" className="mt-2">
						Please select menu types before submitting.
					</Typography>
				)}
			</Box>
			<GetQuotationForm
				open={formOpen}
				handleClose={handleClose}
				onEventIdChange={(eventId) => {
					handleMenusByTypes(eventId);
					setSelectedMenuId(eventId);
				}}
			/>
			<ToastContainer />
		</Box>
	);
};

export default CateringMenu;
